import Vue from 'vue'
import Router from 'vue-router'
import { Message } from 'element-ui';
import { log, getCookie, setCookie } from '@/assets/common.js'
import { ajaxToken } from '@/assets/request.js'
import Login from '@/page/login'
//展示页

import MainFrame from '@/page/introPage/mainFrame'
import Home from '@/page/introPage/Home'
import BuildingIntro from '@/page/introPage/buildingIntro'
import BuildingEnter from '@/page/introPage/buildingEnter'
import Policy from '@/page/introPage/policy'
import Service from '@/page/introPage/service'
import Finacy from '@/page/introPage/finacy'
import Internet from '@/page/introPage/internet'

//表单页
import BuildingEnterForm from '@/page/formPage/buildingEnterForm'
import FinacyForm from '@/page/formPage/finacyForm'
import InternetForm from '@/page/formPage/internetForm'
import PolicyForm from '@/page/formPage/policyForm'
import ServiceForm from '@/page/formPage/serviceForm'
Vue.use(Router)

const router = new Router({
	routes: [{
			path: '/',
			redirect: {
				name: 'Home'
			}
		},
		{
			path: '/login',
			name: 'Login',
			component: Login,
			meta: {
				title: '登录'
			}
		},
		{
			path: '/mainFrame',
			name: 'MainFrame',
			component: MainFrame,
			children: [{
					path: '/home',
					name: 'Home',
					component: Home,
					text: "首页",
					meta: {
						title: '数聚时尚'
					}
				}, {
					path: '/buildingIntro',
					name: 'BuildingIntro',
					component: BuildingIntro,
					text: "服装综合体介绍",
					meta: {
						title: '综合体介绍'
					}
				},
				{
					path: '/buildingEnter',
					name: 'BuildingEnter',
					component: BuildingEnter,
					text: "省级综合体空间入驻",
					meta: {
						title: '入驻省级综合体'
					}
				},
				{
					path: '/policy',
					name: 'Policy',
					component: Policy,
					text: "了解政策",
					meta: {
						title: '了解政策'
					}
				},
				{
					path: '/finacy',
					name: 'Finacy',
					component: Finacy,
					text: "金融支持",
					meta: {
						title: '针对服装产业金融支持'
					}
				},
				{
					path: '/service',
					name: 'Service',
					component: Service,
					text: "配套产业服务",
					meta: {
						title: '配套产业服务'
					}
				},

				// {
				// 	path: '/internet',
				// 	name: 'Internet',
				// 	component: Internet,
				// 	text: "产业互联网平台",
				// 	meta: {
				// 		title: '产业互联网平台'
				// 	}
				// },

			]
		},
		//表单

		{
			path: '/buildingEnterForm',
			name: 'BuildingEnterForm',
			component: BuildingEnterForm,
            meta: {
            	title: '省级综合体入驻申请'
            }
		},
		{
			path: '/finacyForm',
			name: 'FinacyForm',
			component: FinacyForm,
            meta: {
            	title: '金融支持'
            }
		},
		{
			path: '/internetForm',
			name: 'InternetForm',
			component: InternetForm,
            meta: {
            	title: '互联网平台申请'
            }
		},
		{
			path: '/policyForm',
			name: 'PolicyForm',
			component: PolicyForm,
            meta: {
            	title: '配套政策申报'
            }
		},
		{
			path: '/serviceForm',
			name: 'ServiceForm',
			component: ServiceForm,
            meta: {
            	title: '配套产业服务申请'
            }
		}

	]
})
router.beforeEach((to, from, next) => {
	console.log(window.gtag)
  if (window.gtag) {
    gtag('config', 'G-TPNWEP6NBG', {'page_path': to.fullPath});
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }else{
  	document.title="数聚时尚"
  }
  next();
})

router.afterEach((to, from) => {
    
	function restartLogin() {
		Message({
			message: "请先登录",
			type: 'warning',
			duration: 1000
		});
		setTimeout(function() {
			router.push("/login")
		}, 1000)
	}
    //首页保存滚动位置，其他页面从最顶部开始
    if(from.name=="Home"){
        var scrollHeight=document.documentElement.scrollTop || document.body.scrollTop
        sessionStorage.setItem("sjssCurrentHomePageScrollHeight",scrollHeight)
        console.log("存储滚动高度："+scrollHeight)
        // alert('首页保存高度'+scrollHeight)
    }
    if(to.name=="Home"){
        let sessionHeight=sessionStorage.getItem("sjssCurrentHomePageScrollHeight")
        if(sessionHeight){
            // alert('在首页，获取高度'+sessionHeight)
            console.log("是首页，获取session滚动高度，开始滚动："+sessionHeight)
            setTimeout(function(){
                document.body.scrollTop=sessionHeight
                document.documentElement.scrollTop=sessionHeight

            },100)
        }else{
            document.body.scrollTop=0
            document.documentElement.scrollTop=0
        }
    }else{
        document.body.scrollTop=0
        document.documentElement.scrollTop=0
    }
	if(to.name.search("Form") > -1) {
		var isLogined = sessionStorage.getItem("isLogined")
		console.log("isLogined:" + isLogined)
		if(isLogined == 1) {
			console.log("已登录")
		} else {
			var otherSystemToken = getCookie("global_token")
			console.log("otherSystemToken:", otherSystemToken)
			if(!otherSystemToken) {
				restartLogin()
			} else {
				console.log("存在otherSystemToken：" + otherSystemToken)
				//存在其他系统token,校验是否合法
				ajaxToken(otherSystemToken).then(function(res) {
					console.log("单点登陆成功")
					var token = JSON.parse(res.data).token
					var userId = JSON.parse(res.data).userId
					sessionStorage.setItem("isLogined", "1")
					sessionStorage.setItem("token", token)
					sessionStorage.setItem("userId", userId)
					setCookie("global_token", token, 10)
				}, function(res) {
					restartLogin()
				})
			}
		}
		//		Message({
		//			message: "请先登录",
		//			type: 'warning',
		//			duration: 1000
		//		});
		//		setTimeout(function(){
		//			router.push("/login")
		//		},10000)

	}
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js